export const CONNECTION_TYPES = ['4g', '3g', '2g', 'slow-2g', 'saveData'];
export const FALSY_CONNECTIONS_STATE = {
  'slow-2g': false,
  '2g': false,
  '3g': false,
  '4g': false,
  saveData: false
};



// WEBPACK FOOTER //
// ./src/components/DeviceConnection/constants.js